import Link from "next/link";
import logo from "../../public/logo.png";
import Image from "next/image";
export default function LumenIcon() {
  return (
    <Link href={"/"}>
      <Image src={logo} className="w-[56px]" alt="logo" />
    </Link>
  );
}
